import { IMembers } from '../types/state.d';

const sliceMembers = (membersList: IMembers, max: number) =>
  membersList.slice(0, max);

export default sliceMembers;
